import { format, isSameDay, startOfDay } from 'date-fns';
import { PurchaseOrderItem } from '@domain/purchasing';
import { getStatusMilestones, isMilestoneReached } from './milestones';
import { DayTone } from './types';

export const dayKey = (date: Date): string => format(date, 'yyyy-MM-dd');

export const dayToneFromItems = (
  items: PurchaseOrderItem[],
  today: Date,
  date: Date
): DayTone => {
  if (items.length === 0) return 'idle';

  const day = startOfDay(date);
  const milestonesOnDay = items.flatMap((item) =>
    getStatusMilestones(item)
      .filter((milestone) => isSameDay(milestone.date, day))
      .map((milestone) => ({ item, milestone }))
  );

  if (milestonesOnDay.length === 0) return 'idle';

  const hasIncorrect = milestonesOnDay.some(
    ({ item, milestone }) =>
      milestone.date < today && !isMilestoneReached(item, milestone.kind)
  );
  if (hasIncorrect) return 'error';

  const allCorrect = milestonesOnDay.every(({ item, milestone }) => {
    if (milestone.date > today) return false;
    return isMilestoneReached(item, milestone.kind);
  });
  if (allCorrect) return 'success';

  return 'primary';
};
